import * as React from "react";
import {
  IXGUIFieldBase,
  TOnChange,
  TXGUISelectOptionItem,
} from "../../../utils/interfaces/gui/fields.interfaces";

import { Divider, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

const compareProps = (prevProps: any, nextProps: any) => {
  // return isEqual(prevProps, nextProps);
  return prevProps.currentValue === nextProps.currentValue;
};

interface XGUISelectOptionFieldProps extends IXGUIFieldBase {
  onChange: TOnChange<string>;
  currentValue: string;
  options: TXGUISelectOptionItem[];
}

const XGUISelectOptionField: React.FC<XGUISelectOptionFieldProps> = React.memo(
  ({ field, currentValue, onChange, options = [] }) => {
    const id = `XGUI-FIELD-${field.name}`;
    const bp = useBreakpoint();

    return (
      <>
        <Stack
          className="XGUISelectOption"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography component="label" htmlFor={id} width="40%">
            {field.label}
          </Typography>
          <Select
            id={id}
            sx={{ ml: 1 }}
            fullWidth
            value={currentValue ?? field.defaultValue}
            onChange={(e) => {
              onChange(e.target.value, field.name, bp);
            }}
            size="small"
            MenuProps={{
              sx: {
                ".MuiList-root": {
                  p: 0,

                  ".MuiButtonBase-root": {
                    fontSize: 10,
                    px: 1,
                    fontWeight: 600,
                    textAlign: "center",
                  },
                },
              },
            }}
          >
            {options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label ?? opt.value}
              </MenuItem>
            ))}
          </Select>
        </Stack>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 1 }} />
      </>
    );
  },
  compareProps
);

export default XGUISelectOptionField;
